export const MOVING_APP_BUYFLOW_PATH = '/guest/tvi/buy';
